import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.css'],
})
export class InputPasswordComponent {
  error = false;
  value = '';

  @Input() label = 'Contraseña';
  @Input() onlyPass = false;

  @Output() valid = new EventEmitter<boolean>(false);

  isValidString(str: string) {
    // Verifica la longitud mínima
    if (str.length < 8) this.isLength = false;
    else this.isLength = true;

    // Verifica que haya al menos una letra mayúscula
    const hasUpperCase = /[A-Z]/.test(str);
    if (!hasUpperCase) this.hasUpperCase = false;
    else this.hasUpperCase = true;

    // Verifica que haya al menos un carácter especial
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
    const hasSpecialChar = specialCharPattern.test(str);
    if (!hasSpecialChar) this.hasSpecialChar = false;
    else this.hasSpecialChar = true;

    // Toma los números, y verifica que hayan 4
    const numbers = str.match(/\d/g);
    if (!numbers || numbers.length < 4) this.hasNumbers = false;
    else this.hasNumbers = true;

    // Verifica que los numero no sean los mismos
    const nonRepetitive = numbers?.filter((n) => n == numbers[0]);
    if (nonRepetitive?.length === numbers?.length) this.nonRepetitive = false;
    else this.nonRepetitive = true;

    // Verifica que no sean consecutivos
    const consecutive = '1234567890';
    if (numbers) {
      const n = numbers.join('');
      let nInvertido = '';
      for (let i = n.length - 1; i >= 0; i--) {
        nInvertido += n[i];
      }
      const contain =
        consecutive.includes(n) || consecutive.includes(nInvertido);
      if (contain && numbers.length >= 4) {
        this.nonConsecutive = false;
      } else {
        this.nonConsecutive = true;
      }
    }

    if (
      this.isLength &&
      this.hasUpperCase &&
      this.hasNumbers &&
      this.nonRepetitive &&
      this.nonConsecutive &&
      this.hasSpecialChar
    )
      this.valid.emit(true);
    else this.valid.emit(false);
  }

  isLength = true;
  hasUpperCase = true;
  hasNumbers = true;
  nonRepetitive = true;
  nonConsecutive = true;
  hasSpecialChar = true;

  type = 'password';
  icon = 'pi-eye-slash';
  togglePass() {
    this.type = this.type === 'password' ? 'text' : 'password';
    this.icon = this.icon === 'pi-eye-slash' ? 'pi-eye' : 'pi-eye-slash';
  }
}
